import { Constants } from 'utilities/constants';
import { Task } from '../../../../../model/tasks.model';
import { TaskFilters } from '../TasksFilters/TasksFilters';
import { STATUS_MAP, TaskType } from './constants';

export const normalizeStatus = (status: string): TaskType => {
  const statusLower = status.toLowerCase();
  if (STATUS_MAP.TODO.some((s) => s.toLowerCase() === statusLower)) return 'TODO';
  if (STATUS_MAP.IN_PROGRESS.some((s) => s.toLowerCase() === statusLower)) return 'IN_PROGRESS';
  if (STATUS_MAP.DONE.some((s) => s.toLowerCase() === statusLower)) return 'DONE';
  return 'TODO';
};

export const extractAssignees = (task: Task): any => {
  if (task.assignedTo && Array.isArray(task.assignedTo)) {
    const assignedToArray = task.assignedTo as any[];
    const objectAssignees = assignedToArray.filter(
      (assignee: any) => assignee && typeof assignee === 'object' && assignee?.Id && assignee?.Name,
    );
    if (objectAssignees.length > 0) {
      return objectAssignees;
    }
  }

  if (Array.isArray(task.assignedTo) && task.assignedTo.length > 0) {
    return task.assignedTo;
  } else if (
    typeof task.assignedTo === 'object' &&
    task.assignedTo !== null &&
    'Id' in task.assignedTo
  ) {
    return task.assignedTo;
  } else if (typeof task.assignedTo === 'string') {
    return task.assignedTo;
  }
  return task.assignTo || task.assignedTo;
};

export const buildQueryParams = (mine: boolean, params: any, filters?: TaskFilters): any => {
  const queryParams: any = {
    limit: 1000,
    page: 1,
    mine,
  };

  if (params?.id) {
    queryParams.client = params.id;
  }

  if (filters) {
    if (filters.priority?.length) {
      queryParams.priority = filters.priority.join(',');
    }
    if (filters.client?.length) {
      queryParams.client = filters.client.join(',');
    }
    if (filters.recordTypes?.length) {
      queryParams.recordType = filters.recordTypes.join(',');
    }
    if (filters.assignedTo?.length) {
      queryParams.assignedTo = filters.assignedTo.join(',');
    }
    if (filters.search?.trim()) {
      queryParams.search = filters.search.trim();
    }
    if (filters.needAttention) {
      queryParams.needAttention = true;
    }
    if (filters.time?.length) {
      queryParams.dueDate = filters.time[0];
    }
  }

  return queryParams;
};

export const getInitials = (name?: string) => {
  if (!name || typeof name !== 'string') return '';
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
};

export const getPriorityColor = (priority?: string) => {
  const priorityValue = priority || 'Medium';
  const priorityKey = priorityValue === 'Medium' ? 'Normal' : priorityValue;
  return (
    Constants.PriorityTask[priorityKey as 'Normal' | 'Low' | 'High'] ||
    Constants.PriorityTask.Normal
  );
};

export const getPriorityLabel = (priority?: string) => {
  if (!priority) return 'Normal';
  if (Array.isArray(priority)) return priority[0] || 'Normal';
  return priority;
};
